module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_hair_makeup@2x-9b82b0ff8dfdf80a938609551513920f.webp";